// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___QUQ5Z","btn":"style-module__btn___WlU0f","right_part":"style-module__right_part___qZzx_"};
    if(module.hot) {
      // 1697460476260
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  